import { useEffect, useState } from 'react';

/** Cycles 0..count-1 every `intervalMs` while `running`. */
export const useRotatingIndex = (
  count: number,
  intervalMs: number,
  running: boolean,
): number => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!running || count < 2) return undefined;
    const timer = window.setInterval(
      () => setIndex((current) => (current + 1) % count),
      intervalMs,
    );
    return () => window.clearInterval(timer);
  }, [count, intervalMs, running]);

  return count ? index % count : 0;
};
